import { FC } from 'react';
import { SvgProps } from './domain';

const Hand: FC<SvgProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1783_382)'>
        <path
          d='M10.9892 7.90446C11.5104 7.90446 11.933 7.48458 11.933 6.96663C11.933 6.44869 11.5104 6.02881 10.9892 6.02881C10.468 6.02881 10.0455 6.44869 10.0455 6.96663C10.0455 7.48458 10.468 7.90446 10.9892 7.90446Z'
          fill='#006FFF'
        />
        <path
          d='M5.86603 15.5409C5.86603 15.5409 11.933 15.5409 13.0115 15.005C14.0901 14.4691 14.0901 11.7896 13.0115 11.2537C11.933 10.7178 2.73146 11.2537 1.41696 11.2537C0.102461 11.2537 0.877679 19.0243 1.14732 20.2301C1.41696 21.4358 10.4499 21.7038 11.5285 20.766C12.6071 19.8281 20.9659 11.3877 21.2356 10.4499C21.5052 9.51208 21.2356 7.2345 19.4829 7.63643C17.7302 8.03835 14.0901 12.4595 14.0901 12.4595'
          stroke='url(#paint0_linear_1783_382)'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.6861 3.88527C8.76576 3.88527 9.64099 3.01552 9.64099 1.94263C9.64099 0.869747 8.76576 0 7.6861 0C6.60644 0 5.7312 0.869747 5.7312 1.94263C5.7312 3.01552 6.60644 3.88527 7.6861 3.88527Z'
          fill='#006FFF'
        />
        <path
          d='M3.03479 7.90438C3.03479 7.90438 4.38299 4.55501 8.96689 6.16271'
          stroke='#006FFF'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1783_382'
          x1='11'
          y1='21.9999'
          x2='11'
          y2='6.91966'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.2' stopColor='#03E4B3' />
          <stop offset='1' stopColor='#007FF1' />
        </linearGradient>
        <clipPath id='clip0_1783_382'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Hand;
